module.exports = __webpack_public_path__ + "static/sport/banner5.11dcc09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner5.png
// module id = zx1X
// module chunks = 0